import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService} from "ngx-spinner";
import {ClienteService} from "@cliente/cliente.service";
import {MessageService} from "@shell/message.service";
import {NotaCuentaDTO} from "@shared/models/cliente/NotaCuentaDTO";

@Component({
  selector: 'app-modal-nota-facturacion',
  templateUrl: './modal-nota-facturacion.component.html',
  styleUrls: ['./modal-nota-facturacion.component.scss']
})
export class ModalNotaFacturacionComponent implements OnInit {
  miFormulario: FormGroup;
  cargando: boolean = false;
  @Input() cuentaSgc;
  @Input() notaDeCuenta;
  @Output() notaDeCuentaChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private clienteService: ClienteService,
    private messageService: MessageService,
    private activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.miFormulario = this.fb.group({
      mensajeFormControl: [{value: '', disabled: true}, [Validators.required, Validators.maxLength(255)]]
    });
    this.miFormulario.get('mensajeFormControl')?.setValue(this.notaDeCuenta);
  }

  mostrarSpinner() {
    this.cargando = true;
    this.spinner.show("spinnerGrafico");
  }

  ocultarSpinner() {
    this.cargando = false;
    this.spinner.hide("spinnerGrafico");
  }

  // Función para capturar cambios en el textarea
  onTextareaInput() {
    this.notaDeCuenta = this.miFormulario.get('mensajeFormControl')?.value;
  }

  campoEditable(){
    const control = this.miFormulario.get('mensajeFormControl');
    if (control) {
      if (control.disabled) {
        control.enable();
      }
    }
  }

  guardarCambios() {
    this.mostrarSpinner();
    const notaAsoc = new NotaCuentaDTO();
    notaAsoc.nota = this.notaDeCuenta;
    this.clienteService.putNotaDeCuenta(this.cuentaSgc, notaAsoc).
    subscribe(result => {
      this.ocultarSpinner();
      console.log("Capturo nota de cuenta: " + result.notaDeCuenta);
      this.notaDeCuentaChange.emit(this.notaDeCuenta);
      this.messageService.showSuccessMessage("Guardado con éxito.");
      this.cancelar();
    }, (error) => {
      this.messageService.showErrorMessage('Error al guardar: ' + error.message);
      this.ocultarSpinner();
    })
  }

  cancelar() {
    this.activeModal.dismiss();
  }

  get TextAreaOculto(){
    return this.miFormulario.get('mensajeFormControl')?.disabled && this.miFormulario.get('mensajeFormControl')?.value == null;
  }
  get TextAreaNoVacio(){
    return this.miFormulario.get('mensajeFormControl')?.disabled && this.miFormulario.get('mensajeFormControl')?.value != null;
  }
}
